import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { AssociatedDocumentSignedEditionListStore } from "../../store/AssociatedDocumentSignedEditionListStore";

type AssociatedDocumentSignedEditionListDialogsProps = {
  store: AssociatedDocumentSignedEditionListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de AssociatedDocumentSignedEdition.
 * Separado para mantener AssociatedDocumentSignedEditionListPage más limpio.
 */
export const AssociatedDocumentSignedEditionListDialogs: React.FC<AssociatedDocumentSignedEditionListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
